import { Component, Input } from '@angular/core';

import { SharedModule } from '../../_shared/shared.module';

@Component({
  selector: 'app-footer-company',
  templateUrl: './footer-company.component.html',
  standalone: true,
  imports: [SharedModule],
})
export class FooterCompanyComponent {
  @Input() company;
}
